import React, {useEffect} from 'react';
import {Button, Redirect} from 'components';
import {api, modal, useParams} from 'helpers';

export function Invited() {
  const { code } = useParams();
  useEffect(() => {
    api('/collaboration', { code });
    modal(Popup)();
  }, []);
  return (
    <Redirect to="/" />
  );
}

function Popup({ popup }) {
  return (
    <div>
      <p>You have been invited to collaborate!</p>
      <p className="text-right"><Button onClick={popup.close}>Ok</Button></p>
    </div>
  );
}
